import React from 'react';
import { Alert } from 'react-bootstrap';

interface BadCompanyProps {
  heading: string;
  longText: string;
}

export const TurnedOffInCompany: React.FC<BadCompanyProps> = ({
  heading,
  longText,
}) => {
  return (
    <Alert variant="danger">
      <Alert.Heading>{heading}</Alert.Heading>
      <hr />
      <p>{longText}</p>
    </Alert>
  );
};
